import { trickAnalyticEvents } from '@dmp/api/api';
import type { TrickAnalyticEventsPayload } from '@dmp/api/api.types';
import { useGlobalStore } from '@dmp/stores/globalStore';

import { getCachedUserInfo } from './auth';

export const trackEvent = (eventType: string, payload?: Partial<TrickAnalyticEventsPayload>) => {
  return trickAnalyticEvents({
    event_type: eventType,
    user_agent: window.navigator.userAgent,
    referrer_url: window.location.href,
    user: getCachedUserInfo()?.login_uid,
    journey_id: useGlobalStore.getState().journey_id ?? undefined,
    ...payload,
  });

  // const blob = new Blob(
  //   [
  //     JSON.stringify({
  //       event_type: eventType,
  //       user_agent: window.navigator.userAgent,
  //       referrer_url: window.location.href,
  //       user: getCachedUserInfo()?.login_uid,
  //       ...payload,
  //     }),
  //   ],
  //   { type: 'application/json' }
  // );

  // navigator.sendBeacon(baseURL + '/api/v1/metrics/analytic/events/', blob);
};
